// Базовая публичная политика конфиденциальности — TZ §10.
// Полный текст согласовывается с юристом отдельно. На MVP-этапе достаточно
// этой страницы, чтобы юзер мог подтвердить согласие при первом логине.

import { Container, Title, Text, List, Stack, Button } from '@mantine/core';
import { Link } from 'react-router-dom';

export default function PolicyPage() {
    return (
        <Container size="md" py="xl">
            <Stack gap="lg">
                <Title order={1}>Политика конфиденциальности</Title>

                <Text>
                    Сервис «AI-тренажёр для оконщиков» (далее — Сервис) предназначен для
                    отработки навыков продаж сотрудниками компаний-клиентов.
                </Text>

                <div>
                    <Title order={3} mb="xs">
                        Какие данные мы собираем
                    </Title>
                    <List>
                        <List.Item>Логин и ФИО, указанные при создании учётной записи.</List.Item>
                        <List.Item>
                            Текстовые транскрипты учебных диалогов и оценки, сгенерированные
                            ИИ-наставником.
                        </List.Item>
                        <List.Item>Технические логи (IP, user-agent) для безопасности сессий.</List.Item>
                    </List>
                </div>

                <div>
                    <Title order={3} mb="xs">
                        Сколько храним
                    </Title>
                    <List>
                        <List.Item>Транскрипты и оценки — 30 дней по умолчанию.</List.Item>
                        <List.Item>Учётные записи — пока компания-клиент пользуется Сервисом.</List.Item>
                    </List>
                </div>

                <div>
                    <Title order={3} mb="xs">
                        Кому передаём
                    </Title>
                    <Text>
                        Голосовое общение и автоматический разбор обрабатываются через
                        Gemini API (Google). Кроме этого, данные третьим лицам не передаются.
                    </Text>
                </div>

                <div>
                    <Title order={3} mb="xs">
                        Как удалить
                    </Title>
                    <Text>
                        Чтобы удалить ваши данные, обратитесь к Создателю сервиса или
                        администратору вашей компании.
                    </Text>
                </div>

                <Text c="dimmed" size="sm">
                    Аудиозаписи разговоров не сохраняются — на сервере хранится только
                    текстовый транскрипт.
                </Text>

                <Button component={Link} to="/login" variant="light" w="fit-content">
                    ← Назад на вход
                </Button>
            </Stack>
        </Container>
    );
}
